import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

import {
  ContainerQuestion,
  FieldValue,
  FieldName,
  Grid,
  Column,
  Row,
  ImageVideoQuestionLabel,
  AudioQuestionLabel,
} from './styles';

import ProjectCard from '../project-card';
import PreviewStudyButton from '../../../core/components/preview-study-button';

import questionTypes from '../../constants/question-types';

const QuestionsCard = (props) => {
  const {
    edit,
    questions,
    context,
    onClickPreviewStudy,
    previewButtonClicked,
    editText,
    icon,
    isSummary,
    onSaveTemplate,
    isTemplateSaved,
    textButton,
  } = props;

  return (
    <ProjectCard
      title="Questions"
      edit={edit}
      editText={editText}
      onSaveTemplate={onSaveTemplate}
      ButtonText="Save as Template"
      icon={icon}
      isTemplateSaved={isTemplateSaved}
      textButton={textButton}
    >
      <>
        {(_.isEmpty(questions))
          && (<FieldValue>No questions found.</FieldValue>)}

        {!_.isEmpty(questions) && (
          <Grid columns={2}>
            {context && (
              <Row>
                <Column computer={isSummary ? 5 : 4} tablet={4} mobile={8}>
                  <FieldName>
                    Context
                  </FieldName>
                </Column>
                <Column computer={isSummary ? 11 : 12} tablet={12} mobile={8}>
                  <ContainerQuestion>
                    <FieldValue>
                      {context}
                    </FieldValue>
                  </ContainerQuestion>
                </Column>
              </Row>
            )}
            {_.map(questions, (question, questionIndex) => {
              let questionLabel = question.label;

              if (['image_select', 'audio_video'].includes(question.questionType)) {
                if (['wav', 'mp3', 'ogg'].some((extension) => question.videoUrl?.includes(extension))) {
                  questionLabel = <AudioQuestionLabel href={question.videoUrl} />;
                } else {
                  questionLabel = <ImageVideoQuestionLabel href={question.imageUrl || question.videoUrl} />;
                }
              }

              return (
                <Row key={question.id}>
                  <Column computer={isSummary ? 6 : 4} tablet={4} mobile={8}>
                    <FieldName>
                      {`${questionIndex + 1}. ${questionTypes[question.questionType]}`}
                      {question.questionType === 'range' && (
                        <>
                          {`(${question.questionOptions ? question.questionOptions.length : question.range} point)`}
                        </>
                      )}
                    </FieldName>
                  </Column>
                  <Column computer={isSummary ? 10 : 12} tablet={12} mobile={8}>
                    <ContainerQuestion>
                      <FieldValue>
                        {questionLabel}
                        {' ' /** do not remove the empty space. */}
                        {(() => {
                          switch (question.questionType) {
                            case 'single_select':
                            case 'multiple_select':
                              return question.questionOptions.map((option, index) => `${index + 1}) ${option.label} `);
                            case 'ranking':
                              return question.questionOptions.map((option) => option.label).join(', ');
                            default:
                              return '';
                          }
                        })()}
                      </FieldValue>
                    </ContainerQuestion>
                  </Column>
                </Row>
              );
            })}
          </Grid>
        )}
      </>
      {onClickPreviewStudy && (
        <PreviewStudyButton
          onPreviewStudy={onClickPreviewStudy}
          loading={previewButtonClicked}
          loadingPosition="right"
        />
      )}
    </ProjectCard>
  );
};

QuestionsCard.propTypes = {
  edit: PropTypes.func.isRequired,
  questions: PropTypes.arrayOf(PropTypes.shape()),
  context: PropTypes.string,
  onClickPreviewStudy: PropTypes.func,
  previewButtonClicked: PropTypes.bool,
  icon: PropTypes.string,
  editText: PropTypes.string,
  isSummary: PropTypes.bool,
  onSaveTemplate: PropTypes.func,
  isTemplateSaved: PropTypes.shape({}),
  textButton: PropTypes.string,
};

QuestionsCard.defaultProps = {
  questions: null,
  context: '',
  onClickPreviewStudy: null,
  previewButtonClicked: false,
  editText: 'Edit',
  icon: '',
  isSummary: false,
  onSaveTemplate: null,
  isTemplateSaved: null,
  textButton: PropTypes.string,
};

export default QuestionsCard;
